import React from 'react';
import classNames from 'classnames';
import { IconProp } from 'models/Icon';
import { COLOR_VARIANT, ColorVariants } from 'models/Colors';
import { Loader } from 'ncoded-component-library';

import './ActionItem.styles.scss';

export type ActionItemProps = {
  className?: string;
  title: string;
  description: string;
  color?: ColorVariants;
  showLoader?: boolean;
  disabled?: boolean;
  Icon: IconProp;
  onClick: () => void;
};

const ActionItem: React.FC<ActionItemProps> = (props) => {
  const {
    className,
    title,
    description,
    disabled,
    color = COLOR_VARIANT.BLUE,
    showLoader = false,
    Icon,
    onClick,
  } = props;

  const classes = classNames(
    'action-item',
    'clickable',
    color,
    { disabled },
    className,
  );

  return (
    <div className={classes} onClick={() => !disabled && onClick()}>
      {showLoader && <Loader overlay={false} />}

      <span className={classNames('action-item__icon', color)}>
        <Icon />
      </span>

      <span className="action-item__content">
        <span>{title}</span>
        <span>{description}</span>
      </span>
    </div>
  );
};

export default ActionItem;
